import { CircularProgress } from "@material-ui/core";
import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../_metronic/_partials/controls";
import { getBlogLogsAsync } from "../../redux";

// Same label mapping used on the /hdp_blog listing table, duplicated
// here to match this codebase's existing per-page convention (see
// blog/pages/blogLog/blogLog.js) rather than pulling it out into a shared
// module.
const statusLabelMap = {
  draft: "Draft",
  published: "Published",
  pending_review: "Pending Review",
  future: "Future",
  auto_draft: "Auto Draft",
};
const getStatusLabel = (status) => {
  if (status && statusLabelMap[status]) {
    return statusLabelMap[status];
  }
  return status;
};

const HdpBlogLog = () => {
  const { blogId } = useParams();
  const dispatch = useDispatch();
  // Unlike several other blog clones, hdp_blog has its own registered
  // reducer (state.hdp_blog, see rootReducer.js) with namespaced
  // HDP_GET_BLOG_LOGS_* action types (see Hdp_blog/redux/blogAction.js).
  const { isLogsLoading, logBlog, blogLogs } = useSelector(
    (state) => state.hdp_blog || {},
    shallowEqual
  );

  useEffect(() => {
    if (blogId) {
      dispatch(getBlogLogsAsync(blogId));
    }
  }, [blogId, dispatch]);

  return (
    <Card>
      <CardHeader
        title={
          <div className="form-group m-0 d-flex align-items-center">
            <Link className="btn btn-link px-0" to="/hdp_blog">
              <SVG
                className="h-50 align-self-center"
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
              />
              Back
            </Link>
            <span className="pl-2">Hdp Blog - Blog Status History</span>
          </div>
        }
      ></CardHeader>
      <CardBody>
        {isLogsLoading ? (
          <div style={{ flex: "0 0 auto" }}>
            <div style={{ justifyContent: "center" }} className="text-center">
              <div className="basic-verification-loader text-center">
                <CircularProgress />
              </div>
            </div>
          </div>
        ) : !logBlog?._id ? (
          <div className="text-center py-5">Blog not found.</div>
        ) : (
          <>
            <div className="mb-5">
              <div className="font-weight-bold">
                Blog Name: <span className="font-weight-normal">{logBlog.title}</span>
              </div>
              <div className="font-weight-bold">
                Current Status:{" "}
                <span
                  className="font-weight-normal"
                  style={{ textTransform: "capitalize" }}
                >
                  {getStatusLabel(logBlog.status)}
                </span>
              </div>
            </div>
            <div>
              <Table
                hover
                responsive
                className="mb-0 default_table with_hoverbtn mrpdng_tbl"
              >
                <thead>
                  <tr>
                    <th>Old Status</th>
                    <th>New Status</th>
                    <th>Updated By</th>
                    <th>Login Email ID</th>
                    <th>Action</th>
                    <th>Update Time</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {blogLogs && blogLogs.length ? (
                    blogLogs.map((log) => (
                      <tr key={log._id}>
                        <td style={{ textTransform: "capitalize" }}>
                          {getStatusLabel(log.oldStatus)}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {getStatusLabel(log.newStatus)}
                        </td>
                        <td>{log.loginName}</td>
                        <td>{log.loginEmailID}</td>
                        <td>{log.action}</td>
                        <td>{new Date(log.updateTime).toLocaleString()}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {log.newData ? (
                            <Link
                              className="btn btn-sm btn-light-primary"
                              to={`/hdp_blog_log/${blogId}/${log._id}/new`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Blog Details log
                            </Link>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-sm btn-light"
                              disabled
                              title="No data after this action"
                            >
                              New Blog
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No status history found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default HdpBlogLog;
